export enum IStatus{
    Current="Current",
    CurrentAndRevision="Current/Revision",
    History="History",
    Obsolete="Obsolete",
    Planned="Planned",
    Renumbered="Renumbered",
    Revision="Revision"
}